module.exports = __webpack_public_path__ + "img/logo-rdw-particulier.svg";